var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-i-progress") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.64,7.37a.59.59,0,0,0-.83,0L7.37,11.81a.59.59,0,1,0,.83.83L12.64,8.2A.59.59,0,0,0,12.64,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.37,11.37a.59.59,0,1,0,.41-.17A.59.59,0,0,0,11.37,11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.65,8.65a.59.59,0,1,0-.41.17A.59.59,0,0,0,8.65,8.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.52,19a10,10,0,0,0,3.9,1V15.67a5.69,5.69,0,0,1-1.74-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.67,9.42H20a9.94,9.94,0,0,0-1-3.9L15.21,7.68A5.65,5.65,0,0,1,15.67,9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.21,12.33,19,14.5a9.94,9.94,0,0,0,1-3.9H15.67A5.65,5.65,0,0,1,15.21,12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.62,6.67,18.37,4.5a10.14,10.14,0,0,0-2.86-2.86L13.35,5.4A5.75,5.75,0,0,1,14.62,6.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.35,14.62l2.17,3.75a10.14,10.14,0,0,0,2.86-2.86l-3.75-2.17A5.75,5.75,0,0,1,13.35,14.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.08,12.86h0a5.7,5.7,0,0,1,7.26-8L14.5,1.06A10,10,0,0,0,1.34,15h0a10.07,10.07,0,0,0,3.16,3.35l2.16-3.75A5.7,5.7,0,0,1,5.08,12.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.6,15.67V20a9.94,9.94,0,0,0,3.9-1l-2.17-3.75A5.65,5.65,0,0,1,10.6,15.67Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIProgress);
export default __webpack_public_path__ + "static/media/icon-i-progress.9468e6cabdde3b0101f1a7c90a538d03.svg";
export { ForwardRef as ReactComponent };